module.exports = __webpack_public_path__ + "img/CLICK.1e66690c.jpg";